import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { List, Card, Button, message, Modal } from 'antd';
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import _ from 'lodash';
import qs from 'query-string';
import $ from 'jquery';
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST, GOOGLE_MAP_KEY } from '../../configs/env';
import whttp from '../../libs/whttp';
import classnames from 'classnames';
import { __ } from '@wordpress/i18n';

const VC_CONFIG = _.get(window, 'VC_CONFIG', {});
const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');

const stringToBr = (text) => {
  return _.map(_.split(text, '\n'), (line, idx) => (
    <Fragment key={idx}>
      {line}
      <br />
    </Fragment>
  ));
};

// 前端頁面
export default class ServiceUs extends Component {
  state = {
    tabType: 'info',
    query: {},
    serviceInfo: undefined,
    listInfo: {
      current: 1, //目前頁數
      page_size: 10, //一頁幾筆
      total: 1, //以此query條件，總共幾筆資料
      rows: [],
    },
  };

  componentDidMount() {
    const query = AppHelper.getHashParamaters();
    this.loadConfig();
    this.loadData(query);
    this.setState({
      query,
      tabType: AppHelper.getHashValue('tab') || 'info',
    });
  }
  loadConfig = () => {
    this.setState({ isLoadingData: true });

    whttp.get(API_HOST + '/api/v1/system/configs', {}, (state, res) => {
      this.setState({ isLoadingData: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      this.setState({ options: data.options }, () => {
        this.refreshPicker();
      });
    });
  };

  loadData = () => {
    const query = AppHelper.getHashParamaters();

    this.setState({ isFetchData: true });

    whttp.sharedGet(
      API_HOST + `/api/v1/brands`,
      {
        category_id: query.cids,
      },
      (state, res) => {
        this.setState({ isFetchData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        console.log(code, reason, data, res);

        if (state === false || code !== 200) {
          message.warning(reason);
          this.props.history.replace('/cecservice');
          return;
        }

        this.setState({ listInfo: data });
      }
    );
  };
  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh');
  }, 1000);
  handleQueryUpdate = (key, value) => {
    const query = _.get(this, 'state.query', {});
    _.set(query, key, value);
    this.setState({ query });
    window.location.href = this.getSearchPath(query);
  };
  getSearchPath = (query) => {
    console.log(
      'getSearchPath',
      qs.stringify(query, { skipNull: true }),
      query
    );
    return (
      window.location.origin +
      `/brands/#` +
      qs.stringify(query, { skipNull: true })
    );
  };

  render() {
    const serviceInfo = _.get(this, 'state.serviceInfo', {});
    const tabType = _.get(this, 'state.tabType', {});
    const options = _.get(this, 'state.options', {});
    const query = _.get(this, 'state.query', {});
    const listInfo = _.get(this, 'props.brands.listInfo', []);
    const categoryOptions = _.get(options, 'service_categories', []).filter(
      (categoryInfo) => !_.isEmpty(categoryInfo.items)
    );
    let service_categorys = categoryOptions;
    if (query.cid) {
      service_categorys = service_categorys.filter(
        (categoryInfo) => categoryInfo.id == query.cid
      );
    }
    this.refreshPicker();
    return (
      <Fragment>
        <main class='bg-light'>
          {_.map(service_categorys, (categoryInfo) => (
            <div class='container pt-0' key={categoryInfo.id}>
              <h4 class='heading-title align-items-center'>
                {categoryInfo.name}
              </h4>
              <div style={{ textAlign: 'center', fontSize: '18px' }}>
                {__(
                  '您可於賣場找到下列服務(服務項目因各店實際狀況而有所不同, 詳情請洽詢各店服務台)',
                  'cec-plugin-stores'
                )}
              </div>
              <hr class='border-top border-gray mt-0 mb-4' />
              <div class='row no-gutters mx-n3'>
                {_.map(_.get(categoryInfo, 'items', []), (serviceInfo) => (
                  <div class='col-6 col-sm-4 col-md-3 col-lg-auto icon_service-wrap px-3'>
                    <a
                      class='icon_service-block mb-4'
                      role='button'
                      href='#'
                      data-toggle='modal'
                      data-target={`#icon-service-modal-${serviceInfo.id}`}
                      onClick={(e) => e.preventDefault()}
                    >
                      <div class='inner'>
                        <img src={serviceInfo.image} alt={serviceInfo.name} />
                        <span class='name'>
                          {__(serviceInfo.name, 'cec-plugin-stores')}
                        </span>
                      </div>
                    </a>
                    <div
                      class='modal fade'
                      id={`icon-service-modal-${serviceInfo.id}`}
                      tabindex='-1'
                      role='dialog'
                      aria-labelledby='icon-service-modalTitle'
                      aria-hidden='true'
                    >
                      <div
                        class='modal-dialog modal-dialog-centered'
                        role='document'
                      >
                        <div class='modal-content'>
                          <div class='modal-header border-0'>
                            <button
                              class='text-navy close'
                              type='button'
                              data-dismiss='modal'
                              aria-label='Close'
                            >
                              <span class='text-navy' aria-hidden='true'>
                                ×
                              </span>
                            </button>
                          </div>
                          <div class='modal-body px-5 pb-5'>
                            <div class='row'>
                              <div class='col-3'>
                                <img
                                  style={{ width: '100%' }}
                                  src={serviceInfo.image}
                                  alt={serviceInfo.name}
                                  id='service-image'
                                />
                              </div>
                              <div class='col-9'>
                                <h6 class='h4 text-navy mb-4' id='service-name'>
                                  {serviceInfo.name}
                                </h6>
                                <p
                                  class='h6 fw-300 text-font text-justify'
                                  id='service-desc'
                                >
                                  {serviceInfo.desc}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </main>
      </Fragment>
    );
  }
}

// 編輯器
export class ServiceUsEditor extends Component {
  render() {
    return <div className='vu-blocks-editor'>編輯器</div>;
  }
}



// WEBPACK FOOTER //
// ./src/blocks/customer-service/service-us.js